
import {throwError as observableThrowError,  Observable, BehaviorSubject} from 'rxjs';

import {take, filter, catchError, switchMap, finalize} from 'rxjs/operators';
import { Injectable, Injector } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpResponse, HttpUserEvent, HttpErrorResponse } from "@angular/common/http";
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';



@Injectable()
export class RequestInterceptorService implements HttpInterceptor {

    isRefreshingToken: boolean = false;
    tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

    constructor(private injector: Injector, private router: Router) {}

    addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
        token = localStorage.getItem('token_admin');
        return req.clone({ setHeaders: { Authorization: 'Bearer ' + token }});
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
      const authService = this.injector.get(AuthService);

      return next.handle(this.addToken(req, authService.getAuthToken())).pipe(
          catchError(error => {
              if (error instanceof HttpErrorResponse) {
                if(error && error.status === 401 && error.error && error.error.error === 'token_expired'){
                  return this.handle401Error(req, next);
                }
                /* Token no provisto en la request*/
                if(error && error.status === 401 && error.error && error.error.error === 'token_not_provided'){
                  return this.handle400Error(error);
                }
                /* Token expirado */
                if(error && error.status === 401 && error.error && error.error.error === 'token_invalid'){
                  return this.handle400Error(error);
                }
                if(error && error.status === 400 && error.error && error.error.error === 'token_expired'){
                    return this.handle400Error(error);
                  }
                
              } else {
                  return observableThrowError(error);
              }
          }));
    }

    handle400Error(error) {
            // If we get a 400 and the error message is 'invalid_grant', the token is no longer valid so logout.
            return this.logoutUser();
        /*return Observable.throw(error);*/
    }

    handle401Error(req: HttpRequest<any>, next: HttpHandler) {
        if (!this.isRefreshingToken) {
            this.isRefreshingToken = true;

            // Reset here so that the following requests wait until the token
            // comes back from the refreshToken call.
            this.tokenSubject.next(null);

            const authService = this.injector.get(AuthService);
            
            return authService.refreshToken().pipe(
                switchMap((newToken: any) => {
                    if (localStorage.getItem('token_admin')) {
                        this.tokenSubject.next(localStorage.getItem('token_admin'));
                        return next.handle(this.addToken(req, localStorage.getItem('token_admin')));
                    }
                    
                    // If we don't get a new token, we are in trouble so logout.
                    return observableThrowError(newToken);
                    //return this.logoutUser();
                }),
                catchError(error => {
                    // If there is an exception calling 'refreshToken', bad news so logout.
                    console.log(error);
                        //this.router.navigate(['']);
                    return observableThrowError(error);
                    //return this.logoutUser();
                }),
                finalize(() => {
                    this.isRefreshingToken = false;
                }),);
        } else {
            return this.tokenSubject.pipe(
                filter(token => token != null),
                take(1),
                switchMap(token => {
                    return next.handle(this.addToken(req, token));
                }),);
        }
    }

    /*
        This method is only here so the example works.
        Do not include in your code, just use 'req' instead of 'this.getNewRequest(req)'.
    */
    /*
    getNewRequest(req: HttpRequest<any>): HttpRequest<any> {
        if (req.url.indexOf('getData') > 0) {
            return new HttpRequest('GET', 'http://private-4002d-testerrorresponses.apiary-mock.com/getData');
        }

        return new HttpRequest('GET', 'http://private-4002d-testerrorresponses.apiary-mock.com/getLookup');
    }
    */
    logoutUser() {
        // Route to the login page (implementation up to you)
        const authService = this.injector.get(AuthService);
        authService.logout();
        return observableThrowError("logout");
    }
}
